import { Component, Inject, Input, OnChanges, SimpleChanges, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { HttpClient } from "@angular/common/http";
import { AppComponent } from "../app/app.component";
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';
import { ViewChild } from '@angular/core';
import { DomSanitizer } from "@angular/platform-browser";
declare var google: any;

@Component({
    selector: "injury",
    template: require('./injury.component.html'),
    styles: [require('./injury.component.css')]
})
export class InjuryComponent implements OnChanges {

    report: CollisionReport;

    constructor(private appcomponent: AppComponent, private http: HttpClient,
        @Inject('BASE_URL') private baseUrl: string,
        private router: Router, private formBuilder: FormBuilder) {
        this.report = appcomponent.getReport();
        
        //this.report.YourInjuryDriverLicenseNumber = this.report.DriverLicense;
        if (this.report.CollisionReportUniqueId == null) {
            this.reportGetSync();
            this.router.navigate([this.router.url])
        }
        if (this.report.IsNew) {
            this.router.navigate(["home"]);
        }
        this.report.YourInjuryLicensePlate = this.report.VehiclePlate;

        document.body.scrollTop = 0;
    }

    onPhoneInput(): void {
        var v = this.report.YourInjuryMedicalProfessionPhone.replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2-$3");
        this.report.YourInjuryMedicalProfessionPhone = v;
    }

    ngOnChanges(changes: SimpleChanges) {
        if (typeof changes['report'] !== "undefined") {
            // retrieve the report variable change info
            var change = changes['report'];
            // only perform the task if the value has been changed
            if (!change.isFirstChange()) {
                // execute the Http request and retrieve the result
                //DO SOmething
                alert('changed');
            }
        }
        else
            console.log("Undefined");
    }

    onBack(): void {

        if (this.report.EntityType != null && (this.report.EntityType == "PEDESTRIAN" || this.report.EntityType == "CYCLIST")) {
            if (this.report.WereYouInjured) {
                this.ValidateAndPost("prequalification");
            }
            else {
                this.BackAndPost("prequalification");
            }
        }
        else {
            this.BackAndPost("prequalification");
        }
    }

    private BackAndPost(page: string): void {

        this.report.CurrentPage = page;
      //  this.appcomponent.setReport(this.report);
        this.router.navigate([page]);
    }
    onSubmit(): void {
        //   alert('SUCCESS!! :-)\n\n' + JSON.stringify(this.report));
        if (this.report.YourInjuryMedicalProfessionPhone != null && this.report.YourInjuryMedicalProfessionPhone != '' &&
            (this.report.YourInjuryMedicalProfessionPhone.length != 14 ||
            this.report.YourInjuryMedicalProfessionPhone.indexOf('(') == -1 ||
            this.report.YourInjuryMedicalProfessionPhone.indexOf(')') == -1 ||
            this.report.YourInjuryMedicalProfessionPhone.indexOf('-') == -1
            )) {
            alert("Medical Professional Phone number not in the correct format.");
            return;
        }
        if (this.report.EntityType != null && (this.report.EntityType == "PEDESTRIAN" || this.report.EntityType == "CYCLIST")) {
            if (this.report.WereYouInjured) {
                this.ValidateAndPost("otherdriver");
            }
            else {
                this.ValidateAndPost("otherdriver");
            }
        }
        else {
            this.ValidateAndPost("otherdriver");
        }


        
        //GO TO NEXT PAGE
    }

    onInjurySeveritySelected(value: string): void {
        var MajorInjuryAlert = document.getElementById("MajorInjuryAlert");
        var FatalInjuryAlert = document.getElementById("FatalInjuryAlert");
        var SubmitDiv = document.getElementById("submitDiv");

        if (MajorInjuryAlert != null) {
            if(value == "3")
                MajorInjuryAlert.style.display = "block";
            else
                MajorInjuryAlert.style.display = "none";
        }
        if (FatalInjuryAlert != null) {
            if (value == "4")
                FatalInjuryAlert.style.display = "block";
            else
                FatalInjuryAlert.style.display = "none";
        }
        if (SubmitDiv != null) {
            if (value == "3" || value == "4")
                SubmitDiv.style.display = "none";
            else
                SubmitDiv.style.display = "block";
        }
    }

    onYourInjuryTakenToChanged(value: string): void {
        var YourInjuryTakenToOther = document.getElementById("YourInjuryTakenToOther");

        if (YourInjuryTakenToOther != null) {
            if (value == "6")
                YourInjuryTakenToOther.style.display = "block";
            else
                YourInjuryTakenToOther.style.display = "none";
        }
        
    }

    onYourInjurySafetyEquipmentUseChanged(value: string): void {
        var YourInjurySafetyEquipmentUseOther = document.getElementById("YourInjurySafetyEquipmentUseOther");

        if (YourInjurySafetyEquipmentUseOther != null) {
            if (value == "99")
                YourInjurySafetyEquipmentUseOther.style.display = "block";
            else
                YourInjurySafetyEquipmentUseOther.style.display = "none";
        }
    }

    private ValidateAndPost(page: string) {
        if (this.IsValid()) {
            this.report.IsInjuryPageValid = true;
            this.report.CurrentPage = page;
            this.appcomponent.setReport(this.report);
            this.router.navigate([page]);
        }
    }

    onInjuryStatus(status: boolean): void{
        this.report.WereYouInjured = status;
    }

    onInjuryInFiveYear(status: boolean): void{
        this.report.YourInjuryInjuryInFiveYear = status ? "YES" : "NO";
    }

    onConsultingMedical(status: boolean): void{
        this.report.YourInjuryConsultingMedical = status ? "YES" : "NO";
    }

    IsValid(): boolean {

        if (this.report.WereYouInjured == null) {
            alert("Please select if you were injured or not.");
            return false;
        }

        if (this.report.YourInjuryTakenTo == '6' && (this.report.YourInjuryTakenToOther == null || this.report.YourInjuryTakenToOther == "")) {
            alert("Please enter where you were taken to after your injury.");
            return false;
        }
        return true;
    }

    reportGetSync(): void {
        var url = this.baseUrl + "api/report";
        this.http
            .get(url)
            .toPromise().then(result => {
                var v = result as CollisionReport;
                this.report = v;
            });
    }

}